import {
  jb_popup_css_default
} from "./chunk.VGN37XBE.js";
import {
  createFocusTrap
} from "./chunk.PZQJ2H5Y.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  Stackable
} from "./chunk.YYW5LEED.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n,
  o,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-popup/jb-popup.ts
var JbPopup = class extends Initiable(Stackable(r)) {
  constructor() {
    super(...arguments);
    this._internalStack = [];
  }
  createFocusTrap(targets) {
    return createFocusTrap(targets, {
      clickOutsideDeactivates: true,
      escapeDeactivates: true,
      tabbableOptions: {
        getShadowRoot: true
      },
      setReturnFocus: this.returnFocusTo
    });
  }
  async firstUpdated() {
    if (this.animates && this._introPromiseResolve) {
      window.setTimeout(() => {
        this._background.classList.add("visible");
        this._background.addEventListener("transitionend", this._introPromiseResolve, { once: true });
      }, 10);
    }
    window.setTimeout(() => {
      this._slotContainerOuter.style.height = `${this._slotContainerOuter.getBoundingClientRect().height}px`;
    }, 0);
    await this.updateComplete;
    const tabbableChild = this.getSlottedItem();
    this._focusTrapInstance = this.createFocusTrap([tabbableChild]);
    this._focusTrapInstance.activate();
    this.focusSlottedItem();
    this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
  }
  focusSlottedItem() {
    const firstSlottedItem = this.querySelector("& > *");
    firstSlottedItem?.focus();
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true }));
    }, 400);
  }
  getSlottedItem() {
    return this._assignedElements[0]?.shadowRoot.children[0] || this._assignedElements[0]?.children[0];
  }
  async intro() {
    if (!this.animates) {
      return void 0;
    }
    this.focusSlottedItem();
    return new Promise((resolve) => {
      this._introPromiseResolve = resolve;
    });
  }
  async outro() {
    if (!this.animates) {
      return void 0;
    }
    return new Promise((resolve) => {
      this._background.classList.remove("visible");
      this._background.addEventListener("transitionend", resolve, { once: true });
    });
  }
  transitionBack() {
    const previousChild = this._internalStack.pop();
    if (!previousChild) {
      this.unstack();
      return;
    }
    const currentChildElement = this._slot?.assignedElements()[0];
    if (!currentChildElement) {
      return;
    }
    this._transitionChildFromTo(currentChildElement, previousChild);
  }
  transitionTo(nextChildElement) {
    const currentChildElement = this._slot?.assignedElements()[0];
    if (!currentChildElement) {
      return;
    }
    this._internalStack.push(currentChildElement);
    this._transitionChildFromTo(currentChildElement, nextChildElement).then(() => {
    });
  }
  unstacked() {
    this.dispatchEvent(new CustomEvent("jb-focus-fly:hide", { bubbles: true }));
    this._focusTrapInstance?.deactivate();
    this.remove();
  }
  _handlePopupBackgroundClick(event) {
    if (this.preventCloseByBackgroundClick) {
      return;
    }
    if (event.target === this._background || event.target === this._container) {
      this.unstack();
    }
  }
  _handleTransitionEvent(event) {
    this.transitionTo(event.detail.nextChild);
  }
  async _transitionChildFromTo(fromElement, toElement) {
    fromElement.style.setProperty("--background-color", "transparent");
    toElement.style.setProperty("--background-color", "transparent");
    this._slotContainerOuter.style.backgroundColor = "rgb(20, 30, 85)";
    toElement.setAttribute("slot", "transition-helper");
    await this.appendChild(toElement);
    window.setTimeout(() => {
      this._slotContainerInner.addEventListener(
        "transitionend",
        () => {
          this._slotContainerInner.addEventListener(
            "transitionend",
            () => {
              window.setTimeout(() => {
                fromElement.style.setProperty("--background-color", "unset");
                toElement.style.setProperty("--background-color", "unset");
                this._slotContainerOuter.style.backgroundColor = "transparent";
              }, 500);
            },
            { once: true }
          );
          this._slotContainerInner.style.opacity = "1";
          this.removeChild(fromElement);
          toElement.removeAttribute("slot");
          this._slotContainerOuter.style.height = `${toElement.getBoundingClientRect().height}px`;
        },
        { once: true }
      );
      this._slotContainerOuter.style.height = `${toElement.getBoundingClientRect().height}px`;
      this._slotContainerInner.style.opacity = "0";
    }, 0);
    await toElement.updateComplete;
    await this.updateComplete;
    this._focusTrapInstance?.deactivate();
    this._focusTrapInstance = this.createFocusTrap([toElement]);
    this._focusTrapInstance?.activate();
    toElement.focus();
    setTimeout(() => {
      this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 800);
  }
  render() {
    return ke`
      <section
        @click=${this._handlePopupBackgroundClick}
        class="${Rt({ animates: !!this.animates })}"
        style=${`z-index: ${this.zIndex()}`}
      >
        <div class="container">
          <div class="slot-container-col">
            <div class="slot-container-outer">
              <div class="slot-container-inner">
                <slot
                  @jb-popup:close=${this.transitionBack}
                  @jb-popup:close-stack=${this.unstack}
                  @jb-popup:transition=${this._handleTransitionEvent}
                ></slot>
              </div>
            </div>
          </div>
          <div class="transition-helper-container">
            <slot name="transition-helper"></slot>
          </div>
        </div>
      </section>
    `;
  }
};
JbPopup.styles = jb_popup_css_default;
JbPopup.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbPopup.prototype, "animates", 2);
__decorateClass([
  n({ type: Boolean })
], JbPopup.prototype, "preventCloseByBackgroundClick", 2);
__decorateClass([
  n({ type: Object })
], JbPopup.prototype, "returnFocusTo", 2);
__decorateClass([
  o()
], JbPopup.prototype, "_assignedElements", 2);
__decorateClass([
  e("section")
], JbPopup.prototype, "_background", 2);
__decorateClass([
  e(".container")
], JbPopup.prototype, "_container", 2);
__decorateClass([
  r2()
], JbPopup.prototype, "_focusTrapInstance", 2);
__decorateClass([
  e("slot")
], JbPopup.prototype, "_slot", 2);
__decorateClass([
  e(".slot-container-inner")
], JbPopup.prototype, "_slotContainerInner", 2);
__decorateClass([
  e(".slot-container-outer")
], JbPopup.prototype, "_slotContainerOuter", 2);
__decorateClass([
  e('slot[name="transition-helper"]')
], JbPopup.prototype, "_transitionHelperSlot", 2);
JbPopup = __decorateClass([
  customElement("jb-popup")
], JbPopup);

export {
  JbPopup
};
